<template>
  <div>
    <section class="section section-lg">
      <div class="container shape-container d-flex">
          <div class="col px-0">
          <div class="row justify-content-center text-center ">
              <div class="col-lg-6">
                  {{translate(getLanguage(), "Seu resultado total")}}: {{score}}
              </div>
          </div>
          </div>
      </div>
      <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row justify-content-center text-center">
              <div class="col-lg-6">
                <div>
                  <apexchart width="100%" type="area" :options="chartOptions" :series="series"></apexchart>
                </div>
                {{translate(getLanguage(), "Você pontuou no")}} <span v-html="this.percentile(progress)"></span> {{translate(getLanguage(), "por cento")}}
                <p>{{translate(getLanguage(), "de todos os engenheiros que fizeram o teste em nossa plataforma")}} </p>
              </div>
            </div>
          </div>
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-50">
          <div class="row justify-content-center px-50">
            <router-link to="/profile">
              <base-button type="info" size="lg" class="align-center">
                <div class="px-5">
                  <i style="color: white" class="fa fa-check-circle"></i>
                  <span class="btn-inner--text">{{translate(getLanguage(), "Preencha o seu Perfil")}}</span>
                </div>
              </base-button >
            </router-link>
          </div>
          <div class="row justify-content-center px-50">
            <br>
            <div>
              {{translate(getLanguage(), "Sua Performance")}}
              <hr/>
              <p>
                {{translate(getLanguage(), "O assunto no qual conseguiu ir melhor foi")}}
                <strong>{{translate(getLanguage(), bestSubject)}}</strong>
                {{translate(getLanguage(), "e o assunto no qual precisa melhorar foi")}}
                <strong>{{translate(getLanguage(), worstSubject)}}</strong>
              </p>
              <p>
                {{translate(getLanguage(), "O teste cobre uma gama de assuntos, de maneira geral, focados em desenvolvimento de aplicações e fundamentos de Ciência da Computação. Esses são os requisitos principais na maioria das grandes empresas de tecnologia. Seu melhor resultado foi em")}}
                <strong>{{translate(getLanguage(), bestSubject)}}</strong>.
                {{translate(getLanguage(), "Se você deseja aprimorar sua performance para próximas entrevistas, nós recomendamos começar com")}}
                <strong>{{translate(getLanguage(), worstSubject)}}</strong>. 
                {{translate(getLanguage(), "Abaixo você pode encontrar um relatório detalhado de sua performance:")}}
              </p>
            </div>
          </div>
          
        </div>
      </div>
      
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row justify-content-center text-center ">
            <report-card v-for="(tagReport, index) in tagReports" :key="index"
                         :progress="tagReport.progress"
                         :right-questions="tagReport.rightAnswers"
                         :total-questions="tagReport.totalAnswers"
                         :title="tagReport.title"
                         :subTitle="tagReport.subTitle"
                         :content="tagReport.message"
                         :links="tagReport.links"
            >
                
            </report-card>
          </div>
        </div>
      </div>
      <div class="container shape-container d-flex">
        <div class="col mt-4">
          <div class="row justify-content-center px-50">
            <router-link to="/profile">
              <base-button type="info" size="lg" class="align-center">
                <div class="px-5">
                  <i style="color: white" class="fa fa-check-circle"></i>
                  <span class="btn-inner--text">{{translate(getLanguage(), "Preencha o seu Perfil")}}</span>
                </div>
              </base-button >
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ReportCard from "../components/ReportCard";
import translate from "../i18n/i18n.js";
export default {
    components: {ReportCard},
    data: () => ({
      score: "",
      progress: 10,
      bestSubject: "",
      worstSubject: "",
      tagReports: [{
        message: 'opa lol',
        progress: 40,
        rightAnswers: 2,
        totalAnswers: 5,
        title: "lal lel lil",
      }],
      chartOptions: {
        chart: {
            id: 'vuechart-example',
            toolbar: {
                show: false,
            }
        },
        stroke: {
            curve: 'straight',
            width: 5
        },
        xaxis: {
            categories: [-3, -2.8, -2.6, -2.4, -2.2,
                -2, -1.8, -1.6, -1.4, -1.2,
                -1, -0.8, -0.6, -0.4, -0.2,
                0, 0.2, 0.4, 0.6, 0.8,
                1, 1.2, 1.4, 1.6, 1.8,
                2, 2.2, 2.4, 2.6, 2.8, 3],
            legend: {
                show: false,
            },
            labels: {
                show: false,
            },
            type: 'numeric',
        },
        yaxis: {
            labels: {
                show: false,
            }
        },
        legend: {
          show: false
        },
        tooltip: {
            enabled: false,
        },
        dataLabels: {
            enabled: false,
        },
        grid: {
            show: false,
        }
    },
    series: [{
        data: [[-3, 0.004431848412], [-2.8, 0.007915451583], [-2.6, 0.01358296923], [-2.4, 0.0223945303], [-2.2, 0.03547459285], [-2, 0.05399096652], [-1.8, 0.0789501583], [-1.6, 0.1109208347], [-1.4, 0.1497274656], [-1.2, 0.194186055], [-1, 0.2419707245], [-0.8, 0.2896915528], [-0.6, 0.3332246029], [-0.4, 0.3682701403], [-0.2, 0.391042694], [0, 0.3989422804], [0.2, 0.391042694], [0.4, 0.3682701403], [0.6, 0.3332246029], [0.8, 0.2896915528], [1, 0.2419707245], [1.2, 0.194186055], [1.4, 0.1497274656], [1.6, 0.1109208347], [1.8, 0.0789501583], [2, 0.05399096652], [2.2, 0.03547459285], [2.4, 0.0223945303], [2.6, 0.01358296923], [2.8, 0.007915451583], [3, 0.004431848412]]
    }, {
        data: [0.004431848412, 0.007915451583, 0.01358296923, 0.0223945303, 0.03547459285, 0.05399096652, 0.0789501583, 0.1109208347, 0.1497274656, 0.194186055, 0.2419707245, 0.2896915528, 0.3332246029, 0.3682701403, 0.391042694, 0.3989422804, 0.391042694, 0.3682701403, 0.3332246029, 0.2896915528, 0.2419707245, 0.194186055, 0.1497274656, 0.1109208347, 0.0789501583, 0.05399096652, 0.03547459285, 0.0223945303, 0.01358296923, 0.007915451583, 0.004431848412]
    }]
  }),
  computed: {
    scorePercentStyle: function () {
      let scoreArray = this.score.split("/");
      return "width: " + this.percent(scoreArray) + "%";
    },
    scorePercent: function () {
      let scoreArray = this.score.split("/");
      return this.round(this.percent(scoreArray));
    },
  },
  methods: {
    getLanguage(){
      return localStorage.getItem('language') || 0;
    },
    translate: function(language, phrase){
      return translate(language, phrase);
    },
    round(original) {
        return parseFloat(original).toFixed(2);
    },
    percent(scoreArray) {
      let scoreFloat = parseFloat(scoreArray[0])
      let lenFloat = parseFloat(scoreArray[1])
      return scoreFloat/lenFloat * 100
    },
    scoredCurveData: function(categoriesData, curveData, score){
        let scoredCurveData = [];
        if(score <= 25){
            for (let i = 0; i < curveData.length/4; i++) {
                scoredCurveData[scoredCurveData.length] = [categoriesData[i], curveData[i]];
            }
        }
        else if(score < 50){
            for (let i = 0; i < curveData.length/2; i++) {
                scoredCurveData[scoredCurveData.length] = [categoriesData[i], curveData[i]];
            }
        }
        else if(score <= 75){
            for (let i = parseInt(curveData.length/2); i < curveData.length; i++) {
                scoredCurveData[scoredCurveData.length] = [categoriesData[i], curveData[i]];
            }
        }
        else if(score <= 100){
            for (let i = parseInt(curveData.length*3/4); i < curveData.length; i++) {
                scoredCurveData[scoredCurveData.length] = [categoriesData[i], curveData[i]];
            }
        }
        console.log(score);
        console.log(scoredCurveData);
        return scoredCurveData;
    },
    percentile(score){
        if(score <= 25){
            return this.translate(this.getLanguage(),"menor") + " 25 "
        }
        else if(score < 50){
            return this.translate(this.getLanguage(),"menor") + " 50 "
        }
        else if(score <= 75){
            return this.translate(this.getLanguage(),"maior") + " 50 "
        }
        else if(score <= 100){
            return this.translate(this.getLanguage(),"maior") + " 25 "
        }
        return ""
    },
    tagTitle(key) {
        let title = ""
        for (let i = 0; i < key.split("-").length; i++) {
            if (i > 0) {
                title += " ";
            }
            let word = key.split("-")[i];
            word = word[0].toUpperCase() + word.slice(1);
            title += word;
        }
        return title;
    },
    tagSubtitle(progress){
        let subTitle = ""
        if (progress < 30) {
            subTitle += this.translate(this.getLanguage()," - Nós podemos aprimorar esse assunto")
        }
        else if (progress > 30 && progress < 60) {
            subTitle += this.translate(this.getLanguage(), " - Você está num bom caminho, é hora de se tornar ótimo!")
        }
        else if (progress > 60) {
            subTitle += this.translate(this.getLanguage(), " - Mantenha o bom resultado desse assunto")
        }
        return subTitle;
    },
    tagMessage(key) {
        if (key === "data-structures"){
            return this.translate(this.getLanguage(), "Quase todos os problemas em entrevistas requerem que o candidato demonstre um conhecimento avançado em estruturas de dados. Entenda o melhor uso para as principais estruturas de dados pra se destacar");
        }
        else if (key === "system-design"){
            return this.translate(this.getLanguage(), "Apesar de não ser cobrada em todos os níveis de entrevistas entender todas as camadas envolvidas em projetar grandes sistemas pode fazer uma grande diferença na sua oferta de emprego");
        }
        else if (key === "algorithms"){
            return this.translate(this.getLanguage(), "Resolver problemas e criar algoritmos são habilidades chave pra ser um desenvolvedor de software de sucesso. Conhecer os melhores algoritmos para problemas conhecidos podem ser uma grande vantagem");
        }
        else if (key === "fundamentals"){
            return this.translate(this.getLanguage(), "Muitas empresas cobram fundamentos nas entrevistas. Temas como concorrência, sistemas operacionais e lógica de programação são o alicerce da computação");
        }
    },
    tagLinks(key){
        if (key === "data-structures"){
            return [
                {
                    url: "http://calhau.dca.fee.unicamp.br/wiki/images/0/01/EstruturasDados.pdf",
                    text: this.translate(this.getLanguage(), "Aprenda com o curso de estrutura de dados da Unicamp"),
                    language: "ptbr"
                },
                {
                    url: "https://www.alura.com.br/curso-online-estrutura-de-dados",
                    text: this.translate(this.getLanguage(), "Curso da Alura de estrutura de dados com Java"),
                    language: "ptbr"
                },
                {
                    url: "https://www.coursera.org/learn/data-structures",
                    text: this.translate(this.getLanguage(), "Curso de estrutura de dados do Coursera"),
                    language: "en"
                },
                {
                    url: "https://github.com/jwasham/coding-interview-university#data-structures",
                    text: this.translate(this.getLanguage(), "Github completo com varios cursos e tutoriais em estruturas de dados"),
                    language: "en"
                },
                {
                    url: "https://www.youtube.com/watch?v=BRO7mVIFt08&list=PLUl4u3cNGP61Oq3tWYp6V_F-5jb5L2iHb&index=10",
                    text: this.translate(this.getLanguage(), "Youtube com as aulas do professor Erik Demaine do MIT"),
                    language: "en"
                }
            ];
        }
        else if (key === "system-design"){
            return [
                {
                    url: "https://medium.com/xp-inc/design-de-sistemas-distribu%C3%ADdos-apresenta%C3%A7%C3%A3o-d60af6a6c113",
                    text: this.translate(this.getLanguage(), "Aprenda design de sistemas distribuidos com um engenheiro da XP Inc"),
                    language: "ptbr"
                },
                {
                    url: "https://www.udemy.com/course/preparing-for-system-design-interviews/",
                    text: this.translate(this.getLanguage(), "Curso da Udemy focado em entrevistas de desenvolvimento de sistemas de larga escala"),
                    language: "en"
                }
            ];
        }
        else if (key === "algorithms"){
            return [
                {
                    url: "https://www.ic.unicamp.br/~lee/mc448/",
                    text: this.translate(this.getLanguage(), "Aprenda com o curso de algoritmos da Unicamp"),
                    language: "ptbr"
                },
                {
                    url: "https://www.ime.usp.br/~pf/analise_de_algoritmos/lectures.html",
                    text: this.translate(this.getLanguage(), "Aprenda com o curso de algoritmos da USP"),
                    language: "ptbr"
                },
                {
                    url: "https://www.freecodecamp.org/news/tag/algorithms/",
                    text: this.translate(this.getLanguage(), "Conteúdos do Free Code Camp sobre algoritmos"),
                    language: "en"
                },
                {
                    url: "https://www.coursera.org/learn/algorithms-part1",
                    text: this.translate(this.getLanguage(), "Curso de algoritmos do Coursera"),
                    language: "en"
                },
                {
                    url: "https://www.youtube.com/watch?v=HtSuA80QTyo&list=PLUl4u3cNGP61Oq3tWYp6V_F-5jb5L2iHb ",
                    text: this.translate(this.getLanguage(), "Youtube completo de algoritmos do MIT"),
                    language: "en"
                },
                {
                    url: "https://www.khanacademy.org/computing/computer-science/algorithms",
                    text: this.translate(this.getLanguage(), "Curso do Khan Academy de algoritmos"),
                    language: "en"
                },
                {
                    url: "https://github.com/hoanhan101/algo",
                    text: this.translate(this.getLanguage(), "Github com a solução de diversos problemas de algoritmos comuns em entrevistas"),
                    language: "en"
                }
            ];
        }
        else if (key === "fundamentals"){
            return [
                {
                    url: "https://www.cursoemvideo.com/course/curso-de-algoritmo/",
                    text: this.translate(this.getLanguage(), "Aprenda o básico de lógica de programação"),
                    language: "ptbr"
                },
                {
                    url: "https://www.youtube.com/watch?v=XM4lGflQFvA",
                    text: this.translate(this.getLanguage(), "Explicação de como funcionam operações em um computador"),
                    language: "en"
                },
                {
                    url: "https://www.youtube.com/watch?v=iOq5kSKqeR4",
                    text: this.translate(this.getLanguage(), "Explicação de notação assintótica"),
                    language: "en"
                },
                {
                    url: "https://www.youtube.com/watch?v=B3SpQZaAZP4&list=PL1BaGV1cIH4UhkL8a9bJGG356covJ76qN&index=12",
                    text: this.translate(this.getLanguage(), "Explicação de análise amortizada"),
                    language: "en"
                }
            ];
        }
    },
    aggregateTagReports() {
        let tagsReport = [];
        let jsonTagsCount = JSON.parse(localStorage.getItem('tagsCount'));
        let idx = 0;
        console.log(jsonTagsCount);
        if(jsonTagsCount == null) return tagsReport;
        for (let key in jsonTagsCount) {
          if (Object.prototype.hasOwnProperty.call(jsonTagsCount, key)) {
              let value = jsonTagsCount[key];
              let tagReport = {};
              console.log(key);
              console.log(value);
              tagReport.progress = parseInt(this.percent(value.split("/")));
              tagReport.rightAnswers = value.split("/")[0];
              tagReport.totalAnswers = value.split("/")[1];
              tagReport.title = this.tagTitle(key);
              tagReport.subTitle = this.tagSubtitle(tagReport.progress);
              tagReport.message = this.tagMessage(key);
              tagReport.links = this.tagLinks(key);
              console.log(tagReport);
              tagsReport[idx] = tagReport;
              idx++;
          }
        }
        console.log(tagsReport);
        return tagsReport;
    }
  },
  created: async function () {
      this.score = localStorage.getItem("currentScore");
      this.bestSubject = localStorage.getItem("bestSubject");
      this.worstSubject = localStorage.getItem("worstSubject");
      this.progress = parseInt(this.percent(this.score.split("/")));
      this.tagReports = this.aggregateTagReports();
      this.series[1].data = this.scoredCurveData([-3, -2.8, -2.6, -2.4, -2.2,
              -2, -1.8, -1.6, -1.4, -1.2,
              -1, -0.8, -0.6, -0.4, -0.2,
              0, 0.2, 0.4, 0.6, 0.8,
              1, 1.2, 1.4, 1.6, 1.8,
              2, 2.2, 2.4, 2.6, 2.8, 3],
          [0.004431848412, 0.007915451583, 0.01358296923, 0.0223945303, 0.03547459285, 0.05399096652, 0.0789501583, 0.1109208347, 0.1497274656, 0.194186055, 0.2419707245, 0.2896915528, 0.3332246029, 0.3682701403, 0.391042694, 0.3989422804, 0.391042694, 0.3682701403, 0.3332246029, 0.2896915528, 0.2419707245, 0.194186055, 0.1497274656, 0.1109208347, 0.0789501583, 0.05399096652, 0.03547459285, 0.0223945303, 0.01358296923, 0.007915451583, 0.004431848412]
      , this.progress);
  }
};
</script>
<style scoped>
  hr {
    margin-top: 0.1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
